var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HistoryEventType, ScriptHistoryEventMessage } from "../../../messages/scripting/ScriptMessages";
import { BroadcastToPeerMessage, MulticastDelegate } from "flavr-common";
import { busService } from "../../bus";
import { usersService } from "../UsersService";
import { peerFileSystemService } from "./index";
import { fileService, LocalImageFile } from "../../../modules/files";
import { xrService } from "../../xr/XRService";
import { VrToastMessage } from "../../../messages/xr/WebXRMessages";
class HistoryEventService {
    constructor() {
        this.connection = busService.connection("HistoryEventService");
        this.historyList = [];
        this.historyChangedDelegate = new MulticastDelegate();
        this.handleScriptHistoryEventMessage = (msg, meta) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const clientId = (_a = msg.params.clientId) !== null && _a !== void 0 ? _a : usersService.getLocalUser().clientId;
            if (meta.clientId === undefined) {
                this.connection.send(new BroadcastToPeerMessage([new ScriptHistoryEventMessage(Object.assign(Object.assign({}, msg.params), { clientId: clientId }))]));
            }
            if (msg.params.type === HistoryEventType.photo && msg.params.value) {
                let imgUrl;
                const fileId = peerFileSystemService.checkShareUri(msg.params.value);
                if (fileId !== undefined) {
                    try {
                        const peerFile = peerFileSystemService.subscribePeerRemoteFile(fileId);
                        yield peerFile.onLoadedPromise();
                        const newUrl = yield peerFile.getOrCreateUrl();
                        if (newUrl) {
                            imgUrl = newUrl;
                        }
                    }
                    catch (_b) {
                        return;
                    }
                }
                else {
                    const fileId = fileService.generateUUIDFileId();
                    new LocalImageFile(fileId, msg.params.value);
                }
                if (imgUrl) {
                    msg.params.value = imgUrl;
                }
            }
            let userName = "Unknown";
            const user = usersService.getUserByClientId(clientId);
            if (user && user.customUsername) {
                userName = user.customUsername;
            }
            else {
                console.error("[multiplayer] HistoryEventService: User not found or user has no name for clientId:", clientId);
            }
            this.addHistory(userName, Object.assign(Object.assign({}, msg.params), { clientId: clientId }));
        });
        this.connection.subscribeByType(ScriptHistoryEventMessage, this.handleScriptHistoryEventMessage);
    }
    get history() {
        return this.historyList;
    }
    broadCastHistoryEvent(params) {
        // Important: We may NOT use this.connection here, to make things works, we need different connections for sending and receiving (subscribeByType in the constructor)
        busService.connection("HistoryEventServiceSend").send(new ScriptHistoryEventMessage(params));
    }
    addLocalHistoryEvent(params) {
        var _a, _b, _c;
        this.addHistory((_c = (_b = usersService.getUserByClientId((_a = params.clientId) !== null && _a !== void 0 ? _a : "")) === null || _b === void 0 ? void 0 : _b.customUsername) !== null && _c !== void 0 ? _c : "Unknown", params);
    }
    addHistory(userName, params) {
        this.historyList.push({
            userName: userName,
            params,
            timeReceived: Date.now()
        });
        this.showVrToast(userName, params);
        this.historyChangedDelegate.invoke();
    }
    showVrToast(userName, params) {
        var _a, _b;
        if (!xrService.isPresenting()) {
            return;
        }
        const isSelf = params.clientId === usersService.getLocalUser().clientId;
        let message;
        switch (params.type) {
            case HistoryEventType.photo:
                message = isSelf ? "Photo taken" : undefined;
                break;
            case HistoryEventType.annotation:
                message = isSelf ? "Annotation added" : undefined;
                break;
            case HistoryEventType.modelUpload:
                message = isSelf ? "Model uploaded" : `${userName} uploaded a model`;
                break;
            case HistoryEventType.distance:
                message = isSelf ? `Distance measured: ${(_a = params.value) !== null && _a !== void 0 ? _a : "unknown"}` : undefined;
                break;
            case HistoryEventType.userJoined:
                message = `${userName} joined the session`; // Cannot be self
                break;
            case HistoryEventType.userLeft:
                message = `${userName} left the session`; // Cannot be self
                break;
            case HistoryEventType.moisture:
                message = isSelf ? `Moisture measured: ${(_b = params.value) !== null && _b !== void 0 ? _b : "unknown"}` : undefined;
                break;
            case HistoryEventType.startRecording:
                message = isSelf ? "Recording started" : `${userName} started recording`;
                break;
            case HistoryEventType.stopRecording:
                message = isSelf ? "Recording stopped" : `${userName} stopped recording`;
                break;
            default:
                // In other cases, we don't want a toast in VR mode:
                message = undefined;
        }
        if (message) {
            this.connection.send(new VrToastMessage(message));
        }
    }
}
export const historyEventService = new HistoryEventService();
